var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PaletteVariantsEnum } from "../../../lss";
/**
 * Helper to apply correct styling to our InlineNotification component
 */
export var getCardBorderLss = function (palette) {
    var _a;
    var cardLssMap = (_a = {},
        _a[PaletteVariantsEnum.PRIMARY] = {
            bg: 'gray100',
            borderColor: 'gray500'
        },
        _a[PaletteVariantsEnum.SECONDARY] = {
            bg: 'secondary100',
            borderColor: 'secondary400'
        },
        _a[PaletteVariantsEnum.SUCCESS] = {
            bg: 'success100',
            borderColor: 'success400'
        },
        _a[PaletteVariantsEnum.WARNING] = {
            bg: 'warning100',
            borderColor: 'warning600'
        },
        _a[PaletteVariantsEnum.DANGER] = {
            bg: 'danger100',
            borderColor: 'danger400'
        },
        _a);
    return __assign({ border: 'regular' }, cardLssMap[palette]);
};
//# sourceMappingURL=getCardBorderLss.js.map